import React from 'react';
import { IAdvancedRichText } from '../../../../../../inputs';
import { RichTextAdvancedRender } from '../../../../../../inputs/rich-text-advanced/render/RichTextAdvancedRender';
import { ConfigFormItem } from '../../../../../../ui/form/ConfigFormItem';
import { IWidgetComponentProps } from '../../../../IWidgetType';
import { IInputWidget } from '../../IInputWidget';
import { getWidgetProps } from '../util/getWidgetProps';
import { hasWidgetHiddenLabel } from '../util/hasWidgetHiddenLabel';

export interface ISelectWidgetWrapperProps
  extends IWidgetComponentProps<IInputWidget> {
  hidden?: boolean;
  formItemName?: string | string[];
  /** Se fornito, sovrascrive quella del widget */
  label?: IAdvancedRichText | undefined;
  /** Se fornito, sovrascrive quella del widget */
  helpText?: IAdvancedRichText | undefined;
}

/**
 * Componente per gestire in maniera centralizzata lo stile dei widget di tipo select (multi e single)
 */
export function SelectWidgetWrapper(props: ISelectWidgetWrapperProps) {
  const { children, label, helpText } = props;
  const options = getWidgetProps(props);

  return (
    <ConfigFormItem
      hidden={props.hidden}
      name={props.formItemName ?? options.name ?? 'string'}
      label={<RichTextAdvancedRender inline text={label ?? options.label} />}
      help={
        <RichTextAdvancedRender inline text={helpText ?? options.helpText} />
      }
      layout={{
        hideVisualLabel: options.hideLabel,
        removeLabelSpace: hasWidgetHiddenLabel(props.widget),
      }}
      readonly={options.readonly}
    >
      {children}
    </ConfigFormItem>
  );
}
